(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-collection-concierge]:not([data-concierge-ready])').forEach(scene => {
      const buttons = [...scene.querySelectorAll('[data-concierge-choice]')];
      const panels = [...scene.querySelectorAll('[data-concierge-panel]')];
      if (!buttons.length || buttons.length !== panels.length) return;
      function select(value) {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.conciergeChoice === value)));
        panels.forEach(panel => { panel.hidden = panel.dataset.conciergePanel !== value; });
      }
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => select(button.dataset.conciergeChoice));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          buttons[next].focus();
          select(buttons[next].dataset.conciergeChoice);
        });
      });
      select(buttons[0].dataset.conciergeChoice);
      scene.querySelector('.j-concierge__choices').hidden = false;
      scene.dataset.conciergeReady = 'true';
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
